// wheelify-fix.js
(function(){
  const wheelContainerSel = '.wheelify-signupContainer';
  const wheelInputSel = '#cc_spinner_full_name, #cc_spinner_email';
  const newsletterSel = '#newsletter-popup-contact-form-input, .newsletter-popup-form__input';
  let active = false;

  function isVisible(el){
    if(!el) return false;
    const s = window.getComputedStyle(el);
    if(s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    const r = el.getBoundingClientRect();
    return !!(r.width || r.height);
  }

  function setPointerImportant(el, value){
    try { el.style.setProperty('pointer-events', value, 'important'); }
    catch(e){ el.style.pointerEvents = value; }
  }

  function enableEl(el){
    if(!el) return;
    el.disabled = false;
    el.removeAttribute('aria-hidden');
    // restore pointer events (override any stylesheet !important)
    setPointerImportant(el, 'auto');
  }

  function disableEl(el){
    if(!el) return;
    // store previous tabindex if any
    if(!el.hasAttribute('data-wheel-prev-tab')) el.setAttribute('data-wheel-prev-tab', el.getAttribute('tabindex') || '');
    el.setAttribute('tabindex', '-1');
    el.disabled = true;
    el.setAttribute('aria-hidden', 'true');
    setPointerImportant(el, 'none');
    try { el.blur(); } catch(e){}
  }

  function addOverlay(container){
    if(!container) return;
    if(container.querySelector('.wheelify-block-overlay')) return;
    const ov = document.createElement('div');
    ov.className = 'wheelify-block-overlay';
    ov.style.cssText = 'background:transparent';
    if(getComputedStyle(container).position === 'static') container.style.position = 'relative';
    container.insertBefore(ov, container.firstChild);
  }

  function removeOverlay(container){
    if(!container) return;
    const ov = container.querySelector('.wheelify-block-overlay');
    if(ov) ov.remove();
  }

  function focusWheelInput(){
    const wheelInput = document.querySelector(wheelInputSel);
    if(!wheelInput) return;
    enableEl(wheelInput);
    try { wheelInput.focus({preventScroll:true}); } catch(e) { wheelInput.focus(); }
    try {
      if (typeof wheelInput.selectionStart === 'number') {
        const pos = (wheelInput.value || '').length;
        wheelInput.setSelectionRange(pos, pos);
      }
    } catch(e){}
  }

  function activate() {
    if(active) return;
    const container = document.querySelector(wheelContainerSel);
    const wheelInput = document.querySelector(wheelInputSel);
    const newsletter = document.querySelector(newsletterSel);

    if(!container || !wheelInput) return; // nothing to do

    addOverlay(container);
    focusWheelInput();

    // disable newsletter only while popup visible
    if(newsletter) disableEl(newsletter);

    // ensure wheel input captures pointer events (override CSS)
    try { setPointerImportant(wheelInput, 'auto'); } catch(e){}

    active = true;
  }

  function deactivate(){
    if(!active) return;
    const container = document.querySelector(wheelContainerSel);
    const wheelInput = document.querySelector(wheelInputSel);
    const newsletter = document.querySelector(newsletterSel);

    // re-enable newsletter if we disabled it
    if(newsletter){
      newsletter.disabled = false;
      newsletter.removeAttribute('aria-hidden');
      const prev = newsletter.getAttribute('data-wheel-prev-tab');
      if(prev === '') newsletter.removeAttribute('tabindex'); else if(prev) newsletter.setAttribute('tabindex', prev);
      newsletter.removeAttribute('data-wheel-prev-tab');
      setPointerImportant(newsletter, 'auto');
    }

    // ensure wheel input restored (not forced-disabled)
    if(wheelInput){
      wheelInput.disabled = false;
      setPointerImportant(wheelInput, 'auto');
    }

    removeOverlay(container);
    active = false;
  }

  function check(){
    const container = document.querySelector(wheelContainerSel);
    const visible = container && isVisible(container);
    if(visible) activate();
    else deactivate();
  }

  // bootstrap
  document.addEventListener('DOMContentLoaded', function(){
    check();
    // watch for popup insertion/visibility changes
    const obs = new MutationObserver(check);
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style','class'] });

    // fallback polling for a short period (useful for lazy-injected widgets)
    let tries = 0;
    const poll = setInterval(function(){
      check();
      tries++;
      if(tries > 30){ clearInterval(poll); }
    }, 250);

    // cleanup on unload
    window.addEventListener('beforeunload', function(){ deactivate(); obs.disconnect(); clearInterval(poll); });
  });
})();
